module.exports = __webpack_public_path__ + "static/media/ic-texto.c4956d1a.svg";